// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__V9Hbc","total":"AdvancePaymentDetails_total__H2b3t","edit":"AdvancePaymentDetails_edit__7v548"};